<template>
  <div class="app">
    <MiniDashboardHeader></MiniDashboardHeader>
    <div style="margin: 10px">
      <p>
        <input
          id="usernameter"
          v-model="username"
          placeholder="Username"
          :disabled="!cookiesEnabled"
        />
      </p>
      <p>
        <input
          id="password"
          type="password"
          v-model="password"
          placeholder="Password"
          :disabled="!cookiesEnabled"
          @keyup.enter="login"
        />
      </p>
      <button @click="login" :disabled="!cookiesEnabled">Login</button>
      <p v-if="message">{{ message }}</p>
      <div v-if="!cookiesEnabled">
        <h1>Cookies are disabled!</h1>
        <h3>You will not be able to login until you enable cookies for this site.</h3>

        <a
          href="https://www.whatismybrowser.com/guides/how-to-enable-cookies/auto"
          target="_blank"
          >Click here for instructions on how to enable cookies in your browser</a
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

import MiniDashboardHeader from "@/components/MiniDashboardHeader.vue"
import axios from "axios"
import Logger from "js-logger"
Logger.useDefaults()

const logger = Logger.get("Login")

export default defineComponent({
  name: "app",
  data() {
    return {
      username: "",
      password: "",
      message: "",
    }
  },
  computed: {
    loginURL() {
      return process.env.API_URL + "/log_in"
    },

    cookiesEnabled() {
      try {
        document.cookie = "cookietest=1; SameSite=Lax"
        const cookiesEnabled = document.cookie.indexOf("cookietest=") !== -1
        document.cookie =
          "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT; SameSite=Lax"
        return cookiesEnabled
      } catch (e) {
        return false
      }
    },
  },
  components: {
    MiniDashboardHeader,
  },
  methods: {
    attemptLogin(username, password, url) {
      return new Promise((resolve, reject) => {
        // https://stackoverflow.com/a/46412839/5953826
        // withCredentials is required on ajax requests.
        axios
          .post(url, { username, password }, { withCredentials: true })
          .then((response) => {
            return response.data
          })
          .then((json) => {
            logger.debug("Login Success, info: ", json)
            resolve(json)
          })
          .catch((error) => {
            logger.warn("Failed to log in ", error)
            reject(error?.response?.data)
          })
      })
    },

    login() {
      logger.debug("Got login request, path " + window.location.pathname)
      logger.debug("Sending request to loginURL " + this.loginURL)
      this.attemptLogin(this.username, this.password, this.loginURL).then(
        (res: any) => {
          logger.log("Successful login", { res })
          const pathname = window.location.pathname
          this.message = "Login Succeeded, redirecting..."
          if (pathname.startsWith("/login")) {
            if (res.redirect) {
              window.location.href = res.redirect
            } else {
              window.location.href = "/list"
            }
          } else {
            // Preserve existing path
            location.reload()
          }
        },
        (err) => {
          this.message = "failed: " + err?.error
        }
      )
    },
  },
})
</script>

<style></style>
